import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  playText: {
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.4px",
    color: "#ff4e00",
  },
  tapHead: {
    fontWeight: 600,
    fontSize: "48px",
    lineHeight: "60px",
    letterSpacing: "0.4px",
    color: "#212121",
    margin: "24px 0px",
  },
  tapPara: {
    fontWeight: 600,
    fontSize: "24px",
    lineHeight: "32px",
    letterSpacing: "0.4px",
    color: "#212121",
  },
  arrow: {
    width: "22px",
    height: "12px",
    marginLeft: "8px",
  },
  cta: {
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "12px",
    letterSpacing: "0.4px",
    color: "#fff",
    backgroundColor: "#ff4e00",
    padding: "16px",
    borderRadius: "12px",
    display: "flex",
    marginTop: "32px",
  },
  blogCard: {
    backgroundColor:"#212121",
    padding:"24px 120px",
    borderRadius: "0px 12px 12px 0px",
    height:"370px",
    marginTop:"32px"
  },
  eventCard: {
    backgroundColor:"#1f1661",
    padding:"24px 120px",
    borderRadius: "12px 0px 0px 12px",
    height:"370px",
    marginTop:"32px"
  },
  blogText:{
    color:"#fff",
    fontSize:"20px",
    lineHeight:"28px"
  },
  playBook:{
    color:"#fff",
    fontWeight: 600,
    fontSize: "36px",
    lineHeight: "44px",
    letterSpacing: "0.4px",
    margin:"16px 0px"
  },
  mArrow:{
    width:"132px"
  },
  blogCta: {
    color: "#212121",
    backgroundColor: "#fff",
  },
  inlineBlock: {
    display: "inline-block",
  },
  fixHeight: {
    height: "473px",
  },
  containerPadding: {
    padding: "24px 120px",
  },
  socialIcon: {
    marginRight: "24px",
  },
  pointer: {
    cursor: "pointer",
  },
  mt140:{
    marginTop:"140px"
  },
  mt100:{
    marginTop:"100px"
  },
  mt16: {
    marginTop: "16px",
  },
  mtb32:{
    margin:"32px 0px"
  },
  w100: {
    width: "100%",
  },
  w48: {
    width: "48%",
  },
  w40:{
    width:"40%"
  },
  w15:{
    width:"15%"
  },
  "@media (min-width: 851px) and (max-width: 1351px)": {
    playText: {
      fontSize: "22px",
      lineHeight: "30px",
    },
    tapHead: {
      fontSize: "40px",
      lineHeight: "52px",
      margin: "12px 0px",
    },
    tapPara: {
      fontSize: "18px",
      lineHeight: "26px",
    },
    cta: {
      fontSize: "18px",
      padding: "12px",
      marginTop: "24px",
    },
    blogText:{
      fontSize:"18px",
      lineHeight:"26px"
    },
    playBook:{
      fontSize: "32px",
      lineHeight: "40px",
    },

  },
  "@media (min-width: 851px) and (max-width: 1150px)": {
    blogCard:{
      padding:"24px",
      height:"280px"
    },
    eventCard:{
      padding:"24px",
      height:"280px",
      marginBottom:"24px"
    },
    playText: {
      fontSize: "14px",
      lineHeight: "20px",
    },
    tapHead: {
      fontSize:"22px",
      lineHeight:"28px",
      margin:"12px 0px"
    },
    tapPara: {
      fontSize: "16px",
      lineHeight: "22px",
      marginTop:"8px"
    },
    cta: {
      fontSize: "12px",
      padding: "12px",
      marginTop: "12px",
      alignItems:"center"
    },
    arrow: {
      width:"12px",
      height:"8px"
    },
    blogText:{
      fontSize:"14px",
      lineHeight:"20px"
    },
    playBook:{
      fontSize: "22px",
      lineHeight: "28px",
    },
    mlr60:{
      margin:"0px 60px"
    },
    mt24:{
      marginTop:"24px"
    },
    mt140:{
      marginTop:"60px"
    },
    mt100:{
      margin:"70px 0px 24px 0px"
    },
    mArrow:{
      width:"110px"
    },
    pdl24:{
      paddingLeft:"24px"
    },
    pdr24:{
      paddingRight:"24px"
    }
  },
  "@media (min-width: 651px) and (max-width: 850px)": {
    blogCard:{
      padding:"24px",
      height:"280px"
    },
    eventCard:{
      padding:"24px",
      height:"280px",
      marginBottom:"24px"
    },
    playText: {
      fontSize: "14px",
      lineHeight: "20px",
    },
    tapHead: {
      fontSize:"22px",
      lineHeight:"28px",
      margin:"12px 0px"
    },
    tapPara: {
      fontSize: "16px",
      lineHeight: "22px",
      marginTop:"8px"
    },
    cta: {
      fontSize: "12px",
      padding: "12px",
      marginTop: "12px",
      alignItems:"center"
    },
    arrow: {
      width:"12px",
      height:"8px"
    },
    blogText:{
      fontSize:"14px",
      lineHeight:"20px"
    },
    playBook:{
      fontSize: "22px",
      lineHeight: "28px",
    },
    mlr60:{
      margin:"0px 60px"
    },
    mt24:{
      marginTop:"24px"
    },
    mt140:{
      marginTop:"40px"
    },
    mt100:{
      margin:"40px 0px 24px 0px"
    },
    mArrow:{
      width:"80px"
    },
    pdl24:{
      paddingLeft:"24px"
    },
    pdr24:{
      paddingRight:"24px"
    }
  },
  "@media (min-width: 551px) and (max-width: 650px)": {
    blogCard:{
      padding:"24px",
      height:"280px"
    },
    eventCard:{
      padding:"24px",
      height:"280px",
      marginBottom:"24px"
    },
    playText: {
      fontSize: "14px",
      lineHeight: "20px",
    },
    tapHead: {
      fontSize:"22px",
      lineHeight:"28px",
      margin:"12px 0px"
    },
    tapPara: {
      fontSize: "16px",
      lineHeight: "22px",
      marginTop:"8px"
    },
    cta: {
      fontSize: "12px",
      padding: "12px",
      marginTop: "12px",
      alignItems:"center"
    },
    arrow: {
      width:"12px",
      height:"8px"
    },
    blogText:{
      fontSize:"14px",
      lineHeight:"20px"
    },
    playBook:{
      fontSize: "22px",
      lineHeight: "28px",
    },
    mlr60:{
      margin:"0px 60px"
    },
    mt24:{
      marginTop:"24px"
    },
    mt140:{
      marginTop:"40px"
    },
    mt100:{
      margin:"30px 0px 24px 0px"
    },
    mArrow:{
      width:"60px"
    },
    pdl24:{
      paddingLeft:"24px"
    },
    pdr24:{
      paddingRight:"24px"
    }
  },
  "@media (max-width:550px)": {
    blogCard:{
      padding:"24px",
      height:"242px"
    },
    eventCard:{
      padding:"24px",
      height:"242px",
      marginBottom:"24px"
    },
    playText: {
      fontSize: "12px",
      lineHeight: "18px",
    },
    tapHead: {
      fontSize:"18px",
      lineHeight:"24px",
      margin:"12px 0px"
    },
    tapPara: {
      fontSize: "14px",
      lineHeight: "20px",
      marginTop:"8px"
    },
    cta: {
      fontSize: "12px",
      padding: "12px",
      marginTop: "12px",
      alignItems:"center"
    },
    arrow: {
      width:"12px",
      height:"8px"
    },
    blogText:{
      fontSize:"12px",
      lineHeight:"18px"
    },
    playBook:{
      fontSize: "18px",
      lineHeight: "24px",
    },
    mlr60:{
      margin:"0px 16px"
    },
    mt24:{
      marginTop:"24px"
    },
    mt140:{
      marginTop:"50px"
    },
    mt100:{
      margin:"36px 0px 24px 0px"
    },
    mArrow:{
      width:"48px"
    },
    pdl24:{
      paddingLeft:"24px"
    },
    pdr24:{
      paddingRight:"24px"
    }
  },
  flex: {
    display: "flex",
  },
  flexWrap: {
    flexWrap: "wrap",
  },
  spaceBw: {
    justifyContent: "space-between",
  },
  spcaeEvenly: {
    justifyContent: "space-evenly",
  },
  justifyEnd: {
    justifyContent: "end",
  },
  alignStart: {
    alignItems: "flex-start",
  },
  alignCenter: {
    alignItems: "center",
  },
  alignBase: {
    alignItems: "baseline",
  },
  flexCol: {
    flexDirection: "column",
  },
  justifyCenter: {
    justifyContent: "center",
  },
  relative: {
    position: "relative",
  },
  absolute: {
    position: "absolute",
  },
  alignEnd: {
    alignItems: "end",
  },
  flex30: {
    flex: "0 1 30%",
  },
}));

export default style;
